// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-custom-plant-name {
  flex: 1 1;
  text-align: left;
}

.profile-create-custom-plant-btn {
  margin-top: 2vh;
}

.profile-logout-btn {
  margin-top: 5vh;
}

.custom-plant-name {
  flex: 1 1;
  text-align: left;
}

.create-custom-plant-btn {
  margin-top: 2vh;
}

.logout-btn {
  margin-top: 5vh;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Users.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".profile-custom-plant-name {\n  flex: 1;\n  text-align: left;\n}\n\n.profile-create-custom-plant-btn {\n  margin-top: 2vh;\n}\n\n.profile-logout-btn {\n  margin-top: 5vh;\n}\n\n.custom-plant-name {\n  flex: 1;\n  text-align: left;\n}\n\n.create-custom-plant-btn {\n  margin-top: 2vh;\n}\n\n.logout-btn {\n  margin-top: 5vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
